import React, { createContext, useContext } from "react";

export interface PageInfo {
  id: string;
  path: string;
  title: string;
}

interface PagesContextValue {
  pages: PageInfo[];
}

const PagesContext = createContext<PagesContextValue | undefined>(undefined);

export const usePages = () => {
  const context = useContext(PagesContext);
  if (!context) {
    throw new Error("usePages must be used within PagesProvider");
  }
  return context;
};

interface PagesProviderProps {
  pages: PageInfo[];
  children: React.ReactNode;
}

export const PagesProvider: React.FC<PagesProviderProps> = ({ pages, children }) => {
  return <PagesContext.Provider value={{ pages }}>{children}</PagesContext.Provider>;
};
